import type { NavigateFunction } from "react-router-dom";
import type { EntityId } from "./types";

export const familyOverviewPath = "/family/families";
export const familyCreatePath = "/family/new";
export const familyDetailsPath = (id: EntityId): string => `/family/${id}/details`;
export const familyEditPath = (id: EntityId): string => `/family/${id}/edit`;
export const parentDetailsPath = (id: EntityId): string => `/family/parent/${id}/details`;
export const childDetailsPath = (id: EntityId): string => `/family/children/${id}/details`;

export const navigateFamilyFlow = (
  navigate: NavigateFunction,
  target: string,
  direction: "forward" | "back" | "replace" = "forward"
) => {
  navigate(target, {
    replace: direction === "replace",
    state: { direction },
  });
};
